<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core';
import { DialogDescription, useForwardProps, type DialogDescriptionProps } from 'reka-ui';

import { cn } from '@/lib/utils';

import type { HTMLAttributes } from 'vue';

const props = defineProps<DialogDescriptionProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <DialogDescription
    data-slot="dialog-description"
    v-bind="forwardedProps"
    :class="cn('text-muted-foreground text-sm', props.class)"
  >
    <slot />
  </DialogDescription>
</template>
